import { render } from "./DuplicateTestForm.vue?vue&type=template&id=7bfeb2b3&scoped=true"
import script from "./DuplicateTestForm.vue?vue&type=script&lang=js"
export * from "./DuplicateTestForm.vue?vue&type=script&lang=js"

import "./DuplicateTestForm.vue?vue&type=style&index=0&id=7bfeb2b3&scoped=true&lang=scss"

import exportComponent from "/voc/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bfeb2b3"]])

export default __exports__